export default __webpack_public_path__ + "static/media/orangeTheme-girl.ec08d697.jpeg";